/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */




// 

$.getJSON("editor-ishita-bhatt.json", function(data) {
  // 'data' is the parsed JSON object returned from the URL
  console.log(data); // You can see the data in your browser's console
 
  // Now you can work with the data, for example:
  $("#someElement").text(data.someProperty);
  console.log("someElement...............");
});


// fetch('/pages/editor-ishita-bhatt.json')
//   .then(response => response.json())
//   .then(data => {
//     console.log('Page data:', data.page);       // Basic page info
//     console.log('Template sections:', data.sections); // All sections of the template
//   })
//   .catch(error => console.error('Error fetching page JSON:', error));



// $(document).ready(function() {

     var link = $('.Article__Author').find('a').attr('href'); // Show on hover
     $('#hover_box').load(''+link+' #about__expert');
     console.log(link);
  // if(link == ''){
  // $('#hover_box').hide();
  // }

setTimeout(() => {
    if ($('#about__expert').length) {
    // Element exists
    $('#hover_box').show();
} else {
    // Element does not exist
     $('#hover_box').hide();
}
}, 800);




// });